// extracted by mini-css-extract-plugin
export var fadeInOut = "_1h-3";
export var icon = "_1h-4";
export var savedIndicator = "_1h-2";
export var savingIndicator = "_1h-0";
export var spin = "_1h-1";